import { __makeTemplateObject } from '../../../../_virtual/_tslib.js';
import styled from 'styled-components';
var Dot = styled.span(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  background: ", ";\n  border-radius: 50%;\n  ", ";\n  display: inline-block;\n  height: ", "px;\n  width: ", "px;\n  min-width: ", "px;\n"], ["\n  background: ", ";\n  border-radius: 50%;\n  ", ";\n  display: inline-block;\n  height: ", "px;\n  width: ", "px;\n  min-width: ", "px;\n"])), function (_a) {
  var color = _a.color;
  return color;
}, function (_a) {
  var shadow = _a.shadow;
  return shadow && "box-shadow: 0 0 0 2px ".concat(shadow, " ");
}, function (_a) {
  var size = _a.size;
  return size;
}, function (_a) {
  var size = _a.size;
  return size;
}, function (_a) {
  var _b;

  var theme = _a.theme;
  return (_b = theme === null || theme === void 0 ? void 0 : theme.spacings) === null || _b === void 0 ? void 0 : _b.xs;
});
var templateObject_1;
export { Dot };